import { Prompt } from "react-router-dom";
import { Field, reduxForm } from "redux-form";
import Errors from "./../../../shared/errors";
import {
  renderSingleReactSelect
} from "./../../../shared/form-helpers";
import required from "./../../../shared/validation";

function SetDressingForm(props) {
  const {
    handleSubmit,
    handleDelete,
    pristine,
    reset,
    submitting,
    errors,
    mode,
    costumes
  } = props;

  const thisCostume = props.initialValues || {};
  const readOnly = thisCostume.readOnly;

  const costumeOptions = costumes?.map((e) => {
    return { label: e.name, value: e.id };
  });

  const noCostumes = !costumeOptions?.length;

  return (
    <>
      <Prompt when={!pristine} message="" />
      {mode === "add" && <h2 className="menu-label">Add costume to scene</h2>}
      {mode === "edit" && (
        <h2 className="menu-label">Edit costume in scene</h2>
      )}
      {errors && <Errors errors={errors} />}
      {noCostumes && <div>All costumes already added to scene</div>}

      {!noCostumes &&
        <form autoComplete="off" onSubmit={handleSubmit}>
          {mode === "add" && (
            <Field
              name="costumeId"
              label="Costume"
              component={renderSingleReactSelect}
              value={thisCostume.costumeId}
              validate={[required]}
              options={costumeOptions}
              required
              readOnly={readOnly}>
            </Field>
          )}
          {mode === "edit" && (
            <div className="field">
              <label className="label">
                Costumes
              </label>
              <div className="control">
                {thisCostume.name}
              </div>
            </div>
          )}

          {!readOnly && <div className="buttons">
            <button
              type="submit"
              className="button is-primary"
              disabled={pristine || submitting}>
              Save
            </button>

            {mode === "edit" && (
              <button
                type="button"
                className="button is-text"
                disabled={submitting || !props.initialValues}
                onClick={() => handleDelete(thisCostume)}>
                Remove from scene
              </button>
            )}
          </div>}
        </form>}
    </>
  );
}

export default reduxForm({
  form: "SetDressingForm",
  enableReinitialize: true
})(SetDressingForm);
